import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import HourRentalPeriodicHikeTimeDrawer from "components/drawer/HourRentalPeriodicHikeTimeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

const HourRentalPeriodicHikeTimeTable = ({
  hourRentalPeriodicHikeTime,
  perpage,
  currentPage,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const hourRentalPeriodicHikeTimesorted = hourRentalPeriodicHikeTime.sort(
    (a, b) => a.city_names.localeCompare(b.city_names)
  );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <HourRentalPeriodicHikeTimeDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {hourRentalPeriodicHikeTimesorted
          ?.slice(0, perpage)
          .map((data, index) => {
            return (
              <TableRow key={data.uniquekey}>
                <TableCell className="text-sm text-center">
                  {(currentPage - 1) * perpage + index + 1}
                  <span className="font-semibold uppercase text-xs"></span>
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data?.city_names}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["start_time"]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["end_time"]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["vehicle_type_names"]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["hike"]}
                </TableCell>
                <TableCell>
                  <div className="flex justify-center">
                    <EditDeleteButton
                      title={data["Hour Rental"]}
                      id={data.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </>
  );
};

export default HourRentalPeriodicHikeTimeTable;
